import memorizeOne from 'memoize-one';
export var isAnchorSupported = memorizeOne(function () {
  if (window.CSS && window.CSS.supports) {
    return window.CSS.supports('anchor-name: --anchor');
  }
  return false;
});